import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./mobile.css";
import MockTest from "./components/MockTest";
import CustomTestSetup from "./components/CustomTestSetup";
import Bibliografia from "./components/Bibliografia";

function App() {
  const [activeTab, setActiveTab] = useState("mock");

  // Determine valid tabs
  const validTabs = new Set(["mock", "custom", "bibliografia"]);

  // On mount: set active tab from location.hash (if valid)
  useEffect(() => {
    const applyHash = () => {
      const hash = (window.location.hash || "").replace(/^#/, "");
      if (validTabs.has(hash)) {
        setActiveTab(hash);
      } else {
        // ensure hash reflects default tab
        if (!window.location.hash) window.location.hash = "mock";
        setActiveTab("mock");
      }
    };

    applyHash();
    window.addEventListener("hashchange", applyHash);
    return () => window.removeEventListener("hashchange", applyHash);
  }, []); // run once on mount

  // helper to navigate by setting the hash
  const navigateTo = (tab) => {
    if (validTabs.has(tab)) {
      // Setting location.hash will trigger the hashchange listener
      window.location.hash = tab;
    }
  };

  return (
    <div className="container-fluid px-3 px-sm-4 pb-5">
      <style>{`
        body {
          background-color: #f9f9f9;
        }
        @media (max-width: 768px) {
          h4 {
            font-size: 1.2rem;
          }
          .nav-link {
            font-size: 0.95rem;
            padding: 0.5rem 0.8rem;
          }
        }
        .nav-tabs .nav-link.active {
          background-color: #0d6efd;
          color: white !important;
        }
      `}</style>

      <div className="text-center mt-3 mb-4">
        <h4 className="fw-bold">📘 Suite de Preguntas para examen de Instructor (RENAR/ANMAC)</h4>
      </div>
      <div className="text-center mt-3 mb-4">
        <p>Suite de práctica para rendir la evaluación de Instructor de Tiro</p>
        <p>Puede seleccionar la evaluación completa con TODAS las preguntas,</p>
        <p>o armar una evaluación a medida eligiendo las categorias y cantidad de preguntas</p>
      </div>
      <div className="text-center mt-3 mb-4">
        <p><b>Ultima Actualización: </b> 2025-12-12 v2</p>

      </div>

      {/* Tabs */}
      <ul className="nav nav-tabs justify-content-center flex-column flex-sm-row">
        <li className="nav-item">
          <button
            className={`nav-link w-100 ${activeTab === "mock" ? "active" : ""}`}
            onClick={() => navigateTo("mock")}
          >
            🧩 Evaluación Completa
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link w-100 ${activeTab === "custom" ? "active" : ""}`}
            onClick={() => navigateTo("custom")}
          >
            ⚙️ Evaluación Personalizada
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link w-100 ${activeTab === "bibliografia" ? "active" : ""}`}
            onClick={() => navigateTo("bibliografia")}
          >
            📚 Bibliografia
          </button>
        </li>
      </ul>

      {/* Tab content */}
      <div className="tab-content mt-4">
        {activeTab === "mock" && (
          <div className="tab-pane fade show active">
            <MockTest />
          </div>
        )}
        {activeTab === "custom" && (
          <div className="tab-pane fade show active">
            <CustomTestSetup />
          </div>
        )}
        {activeTab === "bibliografia" && (
          <div className="tab-pane fade show active">
            <Bibliografia />
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
